import React from "react";
import {
  getCalculatedHotspotCoordinates,
  getHotspotDisplayState,
} from "../../redux/selectors";
import { useSelector } from "react-redux";
import { offFrameHotspotSize } from "../../config";
import classes from "./bead.module.css";
import clsx from "clsx";

const [w, h] = offFrameHotspotSize;

export function Bead({ frame, usePerFrameVisibility = true, ...rest }) {
  const framifySelector = (selector) => (state) => selector(state, { frame });
  const coordinates = useSelector(
    framifySelector(getCalculatedHotspotCoordinates)
  );
  const beadState = useSelector(framifySelector(getHotspotDisplayState));
  const { x, y } = coordinates ?? {};
  const commonStyle = {
    position: "absolute",
    left: `${x}%`,
    top: `${y}%`,
    width: `${w}px`,
    height: `${h}px`,
    transform: "translate(-50%,-50%)",
    borderRadius: "50%",
    boxSizing: "border-box",
  };
  const conditionalStyle = {};
  const style = { ...commonStyle, ...conditionalStyle };
  return coordinates ? (
    <div
      className={clsx(classes[beadState], classes.common)}
      style={style}
      {...rest}
    ></div>
  ) : null;
}
